// extracted by mini-css-extract-plugin
export default {"overlayContainer":"EUz_fb","overlayContent":"TSatTY","half":"zil9it","fullScreen":"cDYAqx","closeButtonContainer":"KwpALZ","minWidth500px":"i56hql","minWidth500Px":"i56hql"};